import { Button } from '@dropbox/dig-components/buttons';
import { Banner } from '@dropbox/dig-components/banner';
import { atoms } from '@dropbox/dig-foundations';
import React, { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSignerContext } from './signer-experience';

export const ServerErrorBanner = () => {
  const { backendError } = useSignerContext();

  if (!backendError) {
    return null;
  }

  // for now we're always displaying a generic error when this banner is shown
  // we will expand this in the future based on `backendError` type
  return (
    <Banner type="warning">
      <Banner.Message>
        <FormattedMessage
          id="d8d0b40a0567d1c7048c348b1d59f6dd2fe463f4d884976e236f81c677dc9798"
          defaultMessage="Unexpected error occurred. Refresh the page and try again. <a>Refresh</a>"
          values={{
            a: (content: ReactNode) => (
              <Button
                variant="transparent"
                onClick={() => window.location.reload()}
                className={atoms({
                  marginLeft: 'Micro XSmall',
                })}
              >
                {content}
              </Button>
            ),
          }}
          description="Displayed when a server error occurs during signing experience"
        />
      </Banner.Message>
    </Banner>
  );
};
